import type {ShellAccount} from '@wandb/forge-shell-contract';
import {createContext, useContext} from 'react';

// undefined means shell account data is not resolved yet or the app is not
// mounted under the Forge shell; null means resolved while signed out or with
// no accounts.
export const ShellSelectedAccountContext = createContext<
  ShellAccount | null | undefined
>(undefined);

export const useShellSelectedAccount = () =>
  useContext(ShellSelectedAccountContext);
